import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AjaxService } from './services/ajax.service';
import { AuthService } from './auth';
import { AccessTokenService } from './services/access-token.service';
import { StorageService } from './services/storage.service';
import { UtilityService } from './services/utility.service';
import { HttpAuthInterceptor } from './interceptor';
import { FormValidationService } from './services';
import { NestedData } from './pipes/nested-data.pipe';
import { CaseStatus } from './pipes/case-status.pipe';
import { CaseStatusFilter } from './pipes/case-status-filter.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NestedData, CaseStatus, CaseStatusFilter],
  exports: [
    CommonModule,
    NestedData,
    CaseStatus,
    CaseStatusFilter
  ],
  providers: [NestedData, CaseStatus, CaseStatusFilter]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpAuthInterceptor, multi: true },
        AjaxService,
        AuthService,
        AccessTokenService,
        StorageService,
        UtilityService,
        FormValidationService
      ]
    };
  }
}
